export default "__VITE_ASSET__0eeaqdRb__"